import React from 'react';
import ItemInventoryHistory from './ItemInventoryHistory';

interface ItemReceiptHistoryTabProps {
  itemId?: string;
  companyId?: string;
  active: boolean;
}

export default function ItemReceiptHistoryTab({ itemId, companyId, active }: ItemReceiptHistoryTabProps) {
  return <ItemInventoryHistory itemId={itemId} companyId={companyId} direction='receipt' active={active} />;
}
